import {call, put} from 'redux-saga/effects';
import {push} from 'connected-react-router';
import {getUserData, getTextEnums} from '@pluto/rest';
import {envAuth} from 'Login/Redux/LoginReducer';
import {GET_TEXT_ENUMS, LOG_IN} from 'Login/Redux/LoginActions';

export function* initialData() {
    const payload = yield call(getTextEnums);

    yield put({
        type: GET_TEXT_ENUMS,
        payload,
    });
}

export function* login(jwt: string) {
    if (jwt || envAuth) {
        const {status, email, name, roles} = yield call(getUserData);

        yield put({
            type: LOG_IN,
            payload: {
                jwt,
                status,
                email,
                name,
                roles,
            },
        });
        yield call(initialData);
        return;
    }

    push('/login');
}
